
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 7L12 2l9.5 5v2h-19V7zM12 4.26L17.21 7H6.79L12 4.26zM5 11h2v7H5v-7zm8 0v7h-2v-7h2zM2.5 20v2h19v-2h-19zM17 11h2v7h-2v-7z","fill":"currentColor"}})])
          )
        }
      }
    